<template>
  <button
    class="py-4 px-8 rounded-xl ring-red-1 ring-0"
    :class="[`${colour}`, largeText ? 'button-1' : 'button-2']"
    :style="customStyle"
    :type="type"
    :disabled="disabled || loading"
    @click="$emit('click')">
    <!--  Unused ring added to try and import the red-1 colour for the hover state  -->
    <slot> Button</slot>
  </button>
</template>

<script>
export default {
  name: 'CustomButton',
  components: {},
  emits: ['click'],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'button',
    },
    colour: {
      type: String,
      default: 'blue',
    },
    largeText: {
      type: Boolean,
      default: false,
    },
    customStyle: {
      type: String,
      default: null,
    },
  },
}
</script>

<style  scoped>
@import '@/assets/css/themes/themes.css';

button {
  font-weight: 700;
  cursor: pointer;
}

button:disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

.red {
  background-color: #ff0000;
  border-color: #ff0000;
  color: #ffffff;
}

.red:hover {
  background-color: #0037a1;
}

.white {
  border-width: 1px;
  border-style: solid;
  border-color: #333333;
  color: #0064ff;
  background-color: #ffffff;
}

.white:hover {
  background-color: #eeebeb;
}

.grey {
  border-radius: 9999px;
  color: #333333;
  background-color: #eeebeb;
}

.grey:hover {
  background-color: #a0a0a0;
}

/* default */
.blue {
  background-color: #0064ff;
  color: #ffffff;
}

.blue:hover {
  background-color: #0037a1;
}
</style>
